import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';

export const PTL_TASK_LIST = createRequestTypes('PTL_TASK_LIST');

export const getPTLTaskList = {
  request: (payload,freightType) => createAction(PTL_TASK_LIST[REQUEST], { payload }),
  success: (response) => createAction(PTL_TASK_LIST[SUCCESS], { response }),
  failure: (response) => createAction(PTL_TASK_LIST[FAILURE], { response }),
};